import {
  fetchActiveCurrencies,
  fetchCurrencyDefinitions,
  fetchMonthlyExchangeRates,
  addCurrencyTypes,
  postExchangeRates,
  updateDefaultCurrency,
} from '../routines';

function mapActiveCurrencyDefinition(activeCurrencies, currencyDefinitions) {
  const activeCurrencyDefinitionsMap = {};
  activeCurrencies.forEach((activeCurrency) => {
    activeCurrencyDefinitionsMap[activeCurrency.currencyDefinitionId] =
      activeCurrency;
  });

  currencyDefinitions.forEach((currencyDefinition) => {
    const { currencyDefinitionId } = currencyDefinition;

    const currencyDefinitionActive =
      activeCurrencyDefinitionsMap[currencyDefinitionId];

    if (currencyDefinitionActive) {
      activeCurrencyDefinitionsMap[currencyDefinitionId] = {
        ...activeCurrencyDefinitionsMap[currencyDefinitionId],
        ...currencyDefinition,
      };
    }
  });

  return Object.values(activeCurrencyDefinitionsMap);
}

function categorizeCurrencies(currencies) {
  let baseCurrency;
  let defaultCurrency;
  const activeCurrencies = [];

  currencies.forEach((currency) => {
    const { isBase, isDefault } = currency;

    if (isBase) {
      baseCurrency = currency;
    } else {
      activeCurrencies.push(currency);
    }

    if (isDefault) {
      defaultCurrency = currency;
    }
  });

  return { baseCurrency, defaultCurrency, activeCurrencies };
}

const initialState = {
  currencyDefinitions: [],
  baseCurrency: undefined,
  defaultCurrency: undefined,
  activeCurrencies: [],
  monthlyExchangeRates: [],
  areCurrencyDefinitionsLoading: false,
  areActiveCurrenciesLoading: false,
  areExchangeRatesLoading: false,
};

const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCurrencyDefinitions.TRIGGER:
      return {
        ...state,
        areCurrencyDefinitionsLoading: true,
      };
    case fetchCurrencyDefinitions.FAILURE:
      return {
        ...state,
        areCurrencyDefinitionsLoading: false,
      };
    case fetchActiveCurrencies.TRIGGER:
    case updateDefaultCurrency.TRIGGER:
    case addCurrencyTypes.TRIGGER: {
      return {
        ...state,
        areActiveCurrenciesLoading: true,
      };
    }
    case fetchActiveCurrencies.FAILURE:
    case updateDefaultCurrency.FAILURE:
    case addCurrencyTypes.FAILURE:
    case addCurrencyTypes.SUCCESS:
    case updateDefaultCurrency.SUCCESS: {
      return {
        ...state,
        areActiveCurrenciesLoading: false,
      };
    }
    case fetchMonthlyExchangeRates.TRIGGER:
    case postExchangeRates.TRIGGER:
      return {
        ...state,
        areExchangeRatesLoading: true,
      };
    case fetchMonthlyExchangeRates.FAILURE:
    case postExchangeRates.FAILURE:
    case postExchangeRates.SUCCESS:
      return {
        ...state,
        areExchangeRatesLoading: false,
      };
    case fetchCurrencyDefinitions.SUCCESS:
      return {
        ...state,
        currencyDefinitions: action.payload.data,
        areCurrencyDefinitionsLoading: false,
      };
    case fetchActiveCurrencies.SUCCESS: {
      const activeCurrenciesWithDefinition = mapActiveCurrencyDefinition(
        action.payload.data,
        state.currencyDefinitions
      );
      const { baseCurrency, defaultCurrency, activeCurrencies } =
        categorizeCurrencies(activeCurrenciesWithDefinition);

      return {
        ...state,
        baseCurrency,
        defaultCurrency,
        activeCurrencies,
        areActiveCurrenciesLoading: false,
      };
    }
    case fetchMonthlyExchangeRates.SUCCESS:
      return {
        ...state,
        monthlyExchangeRates: action.payload.data,
        areExchangeRatesLoading: false,
      };
    default:
      return state;
  }
};

export default currencyReducer;
